export default {
  title: 'Add-ons für mehr Erfolg',
  description: 'Erweitere deinen Plan mit zusätzlichen Features',
  buttons: {
    continue: 'Weiter',
    no_app_for_now: 'Derzeit keine mobile App verfügbar',
  },
  toasts: {
    something_went_wrong:
      'Es ist ein Fehler aufgetreten. Bitte aktualisieren Sie die Seite oder wenden Sie sich an den technischen Support!',
    failed_to_save_changes:
      'Die Änderungen konnten nicht gespeichert werden. Bitte wenden Sie sich an den technischen Support!',
    changes_got_saved: 'Änderungen wurden erfolgreich gespeichert!',
  },
};
